import React from 'react';
import { components } from '../utils/designTokens';

/**
 * ResizeHandle - A draggable column resize handle
 *
 * Uses design tokens for consistent styling across the application
 */
const ResizeHandle = ({ onResize }) => {
  const handleMouseDown = (e) => {
    e.preventDefault();
    let startX = e.clientX;

    const handleMouseMove = (moveEvent) => {
      const delta = moveEvent.clientX - startX;
      if (delta !== 0) {
        onResize(delta);
        startX = moveEvent.clientX; // Update startX for next delta calculation
      }
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
  };

  const handleTokens = components.table.resizeHandle;

  return (
    <div
      onMouseDown={handleMouseDown}
      style={{
        width: handleTokens.width,
        // Stretch to the full header-row height (blank space below a fixed-height
        // bar reads as broken); minHeight keeps a usable drag target regardless.
        alignSelf: 'stretch',
        height: 'auto',
        minHeight: handleTokens.height,
        cursor: 'col-resize',
        userSelect: 'none',
        flexShrink: 0,
        backgroundColor: handleTokens.defaultColor,
        transition: handleTokens.transition,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.width = handleTokens.hoverWidth;
        e.currentTarget.style.backgroundColor = handleTokens.hoverColor;
        e.currentTarget.style.boxShadow = `0 0 4px ${handleTokens.hoverColor}`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.width = handleTokens.width;
        e.currentTarget.style.backgroundColor = handleTokens.defaultColor;
        e.currentTarget.style.boxShadow = 'none';
      }}
      title="Drag to resize column"
    />
  );
};

export default ResizeHandle;
